module.exports = __webpack_public_path__ + "media/images/athletes/4312-842e1fa08ae70ac224815e2522efdfa5.png";